/** Vite 環境変数（プレフィックス VITE_）の集約 */
function str(v: string | undefined, fallback: string): string {
  return v !== undefined && v !== '' ? v : fallback;
}

/** ミリ秒。空・不正・0以下のときは fallback */
function positiveMs(v: string | undefined, fallback: number): number {
  if (v === undefined || v === '') {
    return fallback;
  }
  const n = Number.parseInt(v, 10);
  return Number.isFinite(n) && n > 0 ? n : fallback;
}

function bool(v: string | undefined, fallback = false): boolean {
  if (v === undefined || v === '') {
    return fallback;
  }
  return ['1', 'true', 'yes', 'on'].includes(v.toLowerCase());
}

export const appEnv = {
  name: str(import.meta.env.VITE_NAME, 'Roomi Meet'),
  dir: str(import.meta.env.VITE_DIR, '/'),
  apiUrl: str(import.meta.env.VITE_API_URL, '/api'),
  websocketUrl: str(import.meta.env.VITE_WEBSOCKET_URL, ''),
  webRtcUrl: str(import.meta.env.VITE_WEB_RTC_URL, 'https://v.tsc-soft.com'),
  webRtcDomain: str(import.meta.env.VITE_WEB_RTC_DOMAIN, 'v.tsc-soft.com'),
  /** @deprecated 定期 verify 廃止。互換のため残置（未使用） */
  tokenCheckIntervalMs: positiveMs(import.meta.env.VITE_TOKEN_CHECK_INTERVAL, 60_000),
  /**
   * アクセストークン有効期限の何ミリ秒前から GET /auth/verify を試すか（401 時のみ refresh）。デフォルト 2 分
   */
  tokenRefreshBeforeExpiryMs: positiveMs(
    import.meta.env.VITE_TOKEN_REFRESH_BEFORE_MS,
    120_000,
  ),
  /**
   * リフレッシュ成功後、API が返す accessTokenExpiresAt がクライアントの Date.now() 以下になる場合
   * （スリープ復帰後の NTP 補正などでクライアントがサーバより進んでいるとき）のフォールバック TTL。
   * バックエンドの JWT アクセス期限（JWT_EXPIRESIN）と揃えること。
   */
  accessTokenClientTtlFallbackMs: positiveMs(
    import.meta.env.VITE_JWT_ACCESS_TTL_FALLBACK_MS,
    900_000,
  ),
  /** Playwright E2E が socket.io transport を観測するための開発専用 hook */
  e2eSocketHookEnabled: bool(import.meta.env.VITE_ENABLE_E2E_SOCKET_HOOK),
};
